import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { UserType } from '../types/auth';
import { AuthLayout } from './AuthLayout';
import { ArrowLeft, Building2, Layout } from 'lucide-react';

export function SignUpForm() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  const handleUserTypeSelect = (type: UserType) => {
    if (type === 'hotel') {
      navigate('/onboarding/hotel');
    } else if (type === 'saas') {
      navigate('/onboarding/saas');
    }
  };

  return (
    <AuthLayout title="Create your account">
      <div className="absolute top-8 left-8">
        <Link
          to="/"
          className="inline-flex items-center text-gray-600 hover:text-gray-900"
        >
          <ArrowLeft className="h-5 w-5 mr-2" />
          Back to Home
        </Link>
      </div>

      {error && (
        <div className="p-4 bg-red-50 border border-red-200 rounded-md">
          <p className="text-sm text-red-600">{error}</p>
        </div>
      )}

      <div className="space-y-6">
        <p className="text-center text-gray-600 mb-8">
          Select your account type
        </p>
        <button
          onClick={() => handleUserTypeSelect('hotel')}
          className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-lg rounded-md text-white bg-[#3C7CD6] hover:bg-[#4A8DE0] transition-colors space-x-3"
        >
          <Building2 className="h-5 w-5" />
          <span>Hotel Account</span>
        </button>
        <button
          onClick={() => handleUserTypeSelect('saas')}
          className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-lg rounded-md text-white bg-[#3C7CD6] hover:bg-[#4A8DE0] transition-colors space-x-3"
        >
          <Layout className="h-5 w-5" />
          <span>SaaS Account</span>
        </button>

        <div className="text-center">
          <Link
            to="/login"
            className="text-sm text-indigo-600 hover:text-indigo-500"
          >
            Already have an account? Sign in
          </Link>
        </div>
      </div>
    </AuthLayout>
  );
}